import type { Room } from '@/lib/rooms';

export const rooms: Room[] = [
  {
    id: 'room-1',
    businessId: '2',
    name: 'Chambre Standard',
    description:
      'Chambre confortable et lumineuse avec lit double, climatisation et vue sur le jardin tropical. Idéale pour les courts séjours.',
    pricePerNight: 35000,
    capacity: 2,
    bedType: 'Lit double',
    images: [
      'https://readdy.ai/api/search-image?query=Cozy%20standard%20hotel%20room%20in%20tropical%20Africa%2C%20comfortable%20double%20bed%20with%20white%20linens%2C%20wooden%20furniture%2C%20garden%20view%20through%20window%2C%20warm%20natural%20daylight%2C%20clean%20modern%20hospitality%20interior%2C%20professional%20photography&width=800&height=500&seq=room-standard-01&orientation=landscape',
    ],
    amenities: ['Climatisation', 'Wi-Fi gratuit', 'Télévision', 'Salle de bain privée'],
    available: true,
    status: 'active',
  },
  {
    id: 'room-2',
    businessId: '2',
    name: 'Chambre Deluxe Vue Mer',
    description:
      'Chambre spacieuse avec balcon privé offrant une vue panoramique sur l\'océan. Lit queen-size, coin salon et minibar.',
    pricePerNight: 55000,
    capacity: 2,
    bedType: 'Lit queen-size',
    images: [
      'https://readdy.ai/api/search-image?query=Deluxe%20hotel%20room%20with%20ocean%20view%20balcony%20in%20Africa%2C%20queen%20size%20bed%2C%20elegant%20coastal%20decor%2C%20panoramic%20sea%20view%2C%20golden%20sunset%20light%2C%20luxury%20hospitality%20photography%2C%20professional%20interior%20design&width=800&height=500&seq=room-deluxe-01&orientation=landscape',
    ],
    amenities: ['Climatisation', 'Wi-Fi gratuit', 'Télévision', 'Salle de bain privée', 'Balcon', 'Vue sur mer', 'Minibar'],
    available: true,
    status: 'active',
  },
  {
    id: 'room-3',
    businessId: '2',
    name: 'Suite Présidentielle',
    description:
      'Suite luxueuse avec chambre séparée, salon, bureau et terrasse privée. Service de majordome et petit-déjeuner inclus.',
    pricePerNight: 120000,
    capacity: 4,
    bedType: 'Lit king-size',
    images: [
      'https://readdy.ai/api/search-image?query=Luxurious%20presidential%20hotel%20suite%20in%20Africa%2C%20separate%20living%20room%20with%20elegant%20sofa%2C%20king%20bed%2C%20marble%20bathroom%2C%20private%20terrace%2C%20warm%20ambient%20lighting%2C%20premium%20hospitality%20interior%2C%20professional%20photography&width=800&height=500&seq=room-suite-01&orientation=landscape',
    ],
    amenities: ['Climatisation', 'Wi-Fi gratuit', 'Télévision', 'Salle de bain privée', 'Balcon', 'Minibar', 'Coffre-fort', 'Petit-déjeuner inclus', 'Bureau'],
    available: true,
    status: 'active',
  },
  {
    id: 'room-4',
    businessId: '2',
    name: 'Chambre Familiale',
    description:
      'Grande chambre familiale avec deux lits superposés et un lit double, parfaite pour les familles avec enfants. Vue sur la piscine.',
    pricePerNight: 70000,
    capacity: 4,
    bedType: 'Lits superposés',
    images: [
      'https://readdy.ai/api/search-image?query=Spacious%20family%20hotel%20room%20in%20Africa%20with%20bunk%20beds%20and%20double%20bed%2C%20colorful%20playful%20decor%2C%20pool%20view%2C%20bright%20cheerful%20atmosphere%2C%20clean%20modern%20hospitality%20interior%2C%20professional%20photography&width=800&height=500&seq=room-family-01&orientation=landscape',
    ],
    amenities: ['Climatisation', 'Wi-Fi gratuit', 'Télévision', 'Salle de bain privée', 'Balcon'],
    available: true,
    status: 'active',
  },
];